export const VERSION = "v3.3.38";
export const EXT_TITLE = "Webint Center";